import mitt from 'mitt';

export const EmitterService = mitt();
